/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Une option de facette (façon e-commerce), avec son nombre de résultats.
 * @export
 * @interface FacetValueDto
 */
export interface FacetValueDto {
    /**
     * 
     * @type {string}
     * @memberof FacetValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacetValueDto
     */
    label: string;
    /**
     * Nombre de résultats si cette option est appliquée (affichage « En cours (812) »)
     * @type {number}
     * @memberof FacetValueDto
     */
    count: number;
}

/**
 * Check if a given object implements the FacetValueDto interface.
 */
export function instanceOfFacetValueDto(value: object): value is FacetValueDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function FacetValueDtoFromJSON(json: any): FacetValueDto {
    return FacetValueDtoFromJSONTyped(json, false);
}

export function FacetValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacetValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'count': json['count'],
    };
}

export function FacetValueDtoToJSON(json: any): FacetValueDto {
    return FacetValueDtoToJSONTyped(json, false);
}

export function FacetValueDtoToJSONTyped(value?: FacetValueDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'count': value['count'],
    };
}

